export const queryParametersFromString = (query: string) => {
    const paramsPairs = query.replace('?', '').split('&');
    return paramsPairs.reduce(
        (acc, parameter) => {
            const [key, value] = parameter.split('=');
            const isValidValue = value !== undefined && value !== null;
            if (isValidValue) {
                acc[key] = String(value);
            }
            return acc;
        },
        {} as Record<string, string>
    );
};
